module.exports = __webpack_public_path__ + "img/image10.d910dc2c.png";